<template>
    <div class="instruction-container">
        <div class="col-12 pb-2 px-0">
            <h3 class="change-password-title">Change or reset your password</h3>
            <div class="change-password-desc">{{CONSTANTS.RESET_PASSWORD_DESC_TEXT}}</div>
        </div>
        <ul>
            <li v-for="(step, index) in CONSTANTS.PASSWORD_RESET_STEPS" :key="index" class="change-password-step py-3">
                <div class="numbered-label">{{index+1}}</div>
                <span @click="trackLinkClick($event)" v-html="step"></span>
            </li>
        </ul>
        <div class="password-requirements">
            <h1 class="mb-3">Password requirements</h1>
            <div class="requirements-desc">
                <div class="sub-title">Passwords must be at least 14 characters long and include at least 3 of the following:</div>
                <div class="requirement-content" v-for="(requirement, index) in CONSTANTS.PASSWORD_REQUIREMENTS" :key="index">
                    <span v-html="requirement"></span>
                </div>
            </div>
            <div class="eval-desc mt-4">
                <div class="sub-title">Additionally, Autodesk passwords are evaluated against the following patterns:</div>
                <div class="requirement-content" v-for="(pattern, index) in CONSTANTS.PASSWORD_EVALUATION_PATTERNS" :key="index">
                    <span v-html="pattern"></span>
                </div>
            </div>
        </div>
        <div class="row form-field-row change-password-button">
            <div class="col text-center text-sm-center text-lg-left">
                <a class="btn flat-btn primary-blue-btn reset-btn text-center" @click="trackResetPasswordButton()" target="_blank" href="https://passwordreset.microsoftonline.com"><span>Start password reset</span></a>
            </div>
        </div>
    </div>
</template>
<script>
import MixpanelMixin from "@/mixins/MixpanelMixin";
export default {
    name: "ResetPasswordInstructions",
    mixins: [MixpanelMixin],
    methods: {
        trackLinkClick(event) {
            if (event.target.id == "authenticator-link"){
                this.trackResetPasswordButton();
            }
        },
        trackResetPasswordButton() {
            this.trackEvent("Microsoft Authenticator - Reset Password Button clicked");
        }
    }
}
</script>
<style scoped>
.instruction-container {
    padding: 60px 80px;
    font-size: 16px;
}
.change-password-button {
    margin-top: 30px;
    margin-bottom: 30px;
    max-width: 275px;
}
.change-password-button >>> span {
    width: 100%;
}
.change-password-desc {
    color: #000;
    font-size: 16px;
    white-space: pre-wrap;
    padding: 10px 20px 30px 0;
}
.change-password-title {
    font-weight: bold;
    line-height: normal;
    font-size: 38px;
    color: #000;
    font-family: artifaktElementBold;
    margin: 0;
}
.numbered-label {
    min-height: 25px; 
    min-width: 25px; 
    border: 1px solid black; 
    margin-right: 10px; 
    text-align: center; 
    border-radius: 3px;
    vertical-align: middle;
    font-family: artifaktElementBold;
}
.password-requirements h1 {
    font-size: 26px;
    font-family: artifaktElementBold;
    padding-top: 20px;
}
.change-password-step span {
    font-weight: 600;
}
.change-password-step /deep/ b {
    font-family: artifaktElementBold;
}
.change-password-step /deep/ a {    
    font-family: artifaktElementBold;
}
.change-password-step /deep/ a:hover {    
    text-decoration: underline !important;
}
.reset-btn {
    color: #fff !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-family: artifaktElementBold;
}
.reset-btn:hover {
    color: #fff !important;
}
.requirement-content {
    font-weight: normal;
    font-family: artifaktElementRegular;
}
.sub-title {
    font-family: artifaktElementBold;
}
ul {
    padding: 0;
}
ul li {
    display: flex;
    align-items: center;
}
@media (max-width: 576px) {
    .instruction-container {
        font-size: 14px;
        padding: 10px 20px;
    }
    .change-password-desc {
        font-size: 14px;
    }
    .change-password-title {
        font-size: 26px;
    }
    .password-requirements h1 {
        font-size: 20px;
    }
}
</style>
